import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import {
	CHeader,CHeaderBrand,CHeaderNav,CHeaderToggler,CHeaderDivider,
	CFooter,
	CRow,
	CCol,
	CContainer,
	CForm,
	CFormInput,
	CFormTextarea,
	CInputGroup,
	CInputGroupText,
	CButton,
	CCard,
	CCardHeader,
	CCardBody,
	CCardFooter,
	CImage,
	CLink,
	CTooltip,
	CSpinner,
	CBadge,
} from '@coreui/react';
import CIcon from '@coreui/icons-react'
import { isMobile } from "react-device-detect";
import {
	MyHeaderProfile,
	MyButton,
	MyDialogform,
	MyDialoglookup,
	//MyDialoglookupapi,
	MyDialogformsubjective,
	MyDialogformobjective,
} from '../../components/index'
import { Konfirm } from '../../helpers/onConfirm'
import { UFunc } from '../../helpers/functions'
import useSatusehat from '../../helpers/useSatusehat'

const pjson 		= require('../../../package.json')
const Rekammedisform 	= (props) => {
	const {
		setLoading,showToast,prosesExpired,setSessionaktif 
	} = props;

	//--DOM--/
	const uNavigate 			= useNavigate();
	const uDispatch 			= useDispatch();
	const { tabel_id } 			= useParams(); 
	const { loadToken } 		= useSatusehat(props);
	//--END DOM--/

	const uBahasaObj  				= useSelector(state => state.listBahasa);
	const uActiveroute  			= useSelector(state => state.activeRoute);
	const uSettingObj 				= useSelector(state => state.gListUserSetting);
	const uIsScrollBottom			= useSelector(state => state.gIsScrollBottom);
	const uEfekapp					= useSelector(state => state.effectApp);
	const uUrlbefore 				= useSelector(state => state.gUrlbefore);

	const uRekammedisID				= parseInt(tabel_id)||0;

	const [uEfekview,setEfekview] 	= React.useState(false);
	const uMaxData					= isMobile ? (uSettingObj.jml_mobile || 10) : (uSettingObj.jml_laporan || 100);
	const uKeywordobj				= JSON.parse(localStorage.getItem("listkeyword")) || {};
	const uTokenObj					= JSON.parse(localStorage.getItem("token")||"{}");
	const uIsHapusallow				= (uTokenObj.userhak==="FREEROLE"||uTokenObj.userhak==="ADMIN");
	const [uHtml500msg,setHtml500msg]	= React.useState(); 
	const [uTimeelapse,setTimeelapse]	= React.useState(0); 
	const uLastinitObj 					= useSelector(state => state.gInitRMSelected);

	const uTokensatusehatObj			= JSON.parse(localStorage.getItem("tokensatusehat") || "{}");
	const [uDatamainObj,setDatamainObj]		= React.useState({})
	const [uDataanamnaseArr,setDataanamanseArr]	= React.useState([])
	const [uDatadiagnosaArr,setDatadiagnosaArr]	= React.useState([])
	const [uToggleditObj,setToggleditObj]	= React.useState({})
	const [uDataloading,setDataloading] 	= React.useState(false);
	const [uTriggeredit,setTriggeredit] = React.useState(false);

	//--DLG_FORMSUBJECTIVE--/
	const uDatasubjectiveObj 			= useSelector(state => state.gDatasubjective) || {};
	const uISDlgformsubjectivesimpan 	= useSelector(state => state.gISSubjectivesimpan) || false;
	const [uISDlgformsubjectiveshow,setDlgformsubjectiveshow]	= React.useState(false)
	//--END DLG_FORMSUBJECTIVE--/

	//--DLG_FORMOBJECTIVE--/
	const uDataobjectiveObj 			= useSelector(state => state.gDataobjective) || {};
	const uISDlgformobjectivesimpan 	= useSelector(state => state.gISObjectivesimpan) || false;
	const [uISDlgformobjectiveshow,setDlgformobjectiveshow]	= React.useState(false)
	//--END DLG_FORMOBJECTIVE--/

	//--DLG_FORM--/
	const [uDlgformObj,setDlgformObj]		= React.useState({})
	const [uISDlgformshow,setDlgformshow]	= React.useState(false)
	//--END DLG_FORM--/

	//---DLG_LOOKUP--/
	const [uISDlglookupshow,setDlglookupshow]	= React.useState(false);
	const [uDlglookupObj,setDlglookupObj]		= React.useState({});
	//---END DLG_LOOKUP--/

	/*//---DLG_LOOKUP_API--/
	const [uISDlglookupapishow,setDlglookupapishow]	= React.useState(false)
	const [uDlglookupapiObj,setDlglookupapiObj]	= React.useState({})
	//---END DLG_LOOKUP_API--*/

	//---HANDEL--/
	const hdlKlikBack = () => { uNavigate(-1); }
	const hdlKlikToggleeditmain = async(_JENIS,_IDITEM) => {
		_IDITEM		= parseInt(_IDITEM)||0;
		_JENIS		= _JENIS || "";
		setToggleditObj({});
		if(uToggleditObj.jenis === _JENIS 
			&& (parseInt(uToggleditObj.tabel_id)||0) === 0) {
			return;
		}

		let vValue;
		/*if(_JENIS === "DIAGNOSAMAIN") {
			vValue = parseInt(uDatamainObj.diagnosa_main_id) || 0;
		} else if(_JENIS === "DIAGNOSAMAINTEKS") {
			vValue = uDatamainObj.diagnosa_main_teks || "";
		} else//-*/ if(_JENIS === "SUBJECTIVE") {
			vValue = parseInt(uDatamainObj.anamnase_id) || "";
		} else if(_JENIS === "OBJECTIVE") {
			vValue = uDatamainObj.objective_str || "";
		}

		setToggleditObj({
			jenis: _JENIS,
			value: vValue,
		});

 		/*//--LANGSUNG_LOOKUP--/
		if(_JENIS === "DIAGNOSAMAIN"
			) {
			hdlKlikDiagnosalookup();
			return;
		}
		//--END LANGSUNG_LOOKUP--/

		//--HAPUS_DIAGNOSA_SEKUNDER--/
		if(_JENIS === "DIAGNOSASEKUNDERHAPUS") {
			const vDiagnosasekunderArr	= JSON.parse(uDatamainObj.diagnosa_sekunder_str || "[]");
			const vIdxsekunder 			= UFunc.getObjectIndeks(vDiagnosasekunderArr,_IDITEM,"diagnosa_sekunder_id");
	
			if(await Konfirm("Diagnosa Sekunder <b>"+
					(vDiagnosasekunderArr[vIdxsekunder].diagnosa_sekunder_caption||"UNDF")+"</b> Akan Dihapus.."+
				"<br/>Apakah Anda Yakin ?"+
				"")) setTriggeredit(true);
			return;
		}
		//--END HAPUS_DIAGNOSA_SEKUNDER--*/

		if(_JENIS === "SUBJECTIVE") {
			hdlKlikAnamnesalookup();
			return;
			/*//--TIDAK_DIPAKAI--/
			const vSubjectiveObj	= JSON.parse(vValue || "{}");
			if(!vSubjectiveObj.anamnase)
				vSubjectiveObj.anamnase_caption = uDatamainObj.anamnase;
			if(!vSubjectiveObj.anamnase_id)
				vSubjectiveObj.anamnase_id = uDatamainObj.anamnase_id;

			if((parseInt(uDatamainObj.anamnase_id)||0) <= 0) 
				vSubjectiveObj.anamnase_caption = undefined;

			uDispatch({type: "set", gDatasubjective: vSubjectiveObj});
			setDlgformsubjectiveshow(true);
			//--END TIDAK_DIPAKAI--*/
		} else if(_JENIS === "OBJECTIVE") {
			uDispatch({type: "set", gDataobjective: JSON.parse(vValue || "{}")});
			setDlgformobjectiveshow(true);
		}

		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);

			let vElfocus;
			if(_JENIS === "DIAGNOSAMAINTEKS")
				vElfocus	= document.getElementById("inpdiagnosaket");
			else if(_JENIS === "SUBJECTIVE")
				vElfocus	= document.getElementById("inpkeluhanutama");
			else if(_JENIS === "OBJECTIVE")
				vElfocus	= document.getElementById("inptekanandarahatas");

			vElfocus && vElfocus.focus();
		},350)
	}
	const hdlKlikToggleprosesmain = () => {
		setTriggeredit(true);
	}

	const hdlKlikToggleedititem = (_IDTABEL,_JENIS) => {
		_IDTABEL 	= parseInt(_IDTABEL)||0;
		_JENIS		= _JENIS || "";

		setToggleditObj({});
		if(uToggleditObj.jenis === _JENIS && uToggleditObj.tabel_id === _IDTABEL) {
			return;
		}

		const vArridx	= UFunc.getObjectIndeks((uDatamainObj.items_arr||[]),_IDTABEL);
		let vValue;
		if(_JENIS === "KETGIGI")
			vValue		= (((uDatamainObj.items_arr||[])[vArridx] || {}).ket_gigi || "").trim();
		else if(_JENIS === "DIAGNOSASEKUNDER")
			vValue		= parseInt(((uDatamainObj.items_arr||[])[vArridx] || {}).diagnosa_id) || 0;
		else if(_JENIS === "TINDAKANTEKS")
			vValue		= (((uDatamainObj.items_arr||[])[vArridx] || {}).tindakan || "").trim();
		else if(_JENIS === "DIAGNOSATEKS")
			vValue		= (((uDatamainObj.items_arr||[])[vArridx] || {}).diagnosa_ket || "").trim();
		/*else if(_JENIS === "TINDAKANCAPTION")
			vValue		= parseInt(((uDatamainObj.items_arr||[])[vArridx] || {}).tindakan_id) || 0;
		else if(_JENIS === "TINDAKANCAPTIONHAPUS")
			vValue		= (((uDatamainObj.items_arr||[])[vArridx] || {}).tindakan_caption || "").trim();//-*/

		setToggleditObj({
			tabel_id : _IDTABEL,
			jenis: _JENIS,
			value: vValue,
		});

		//--LANGSUNG_HAPUS--/
		if(_JENIS === "DIAGNOSASEKUNDERHAPUS") {
			hdlKlikDiagnosasekunderhapus();
			return;
		}
		//--END LANGSUNG_HAPUS--/

		/*//--LANGSUNG_HAPUS--/
		if(_JENIS === "TINDAKANCAPTIONHAPUS") {
			hdlKlikTindakanhapus();
			return;
		}
		//--END LANGSUNG_HAPUS--/

		//--LANGSUNG_LOOKUP--/
		if(_JENIS === "TINDAKANCAPTION") {
			hdlKlikTindakanlookup();
			return;
		}
		//--END LANGSUNG_LOOKUP--*/

		//--LANGSUNG_LOOKUP--/
		if(_JENIS === "DIAGNOSASEKUNDER") {
			hdlKlikDiagnosalookup();
			return;
		}
		//--END LANGSUNG_LOOKUP--/

		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);

			let vElfocus;
			if(_JENIS === "KETGIGI")
				vElfocus	= document.getElementById("inpnomorgigi");
			else if(_JENIS === "TINDAKANTEKS")
				vElfocus	= document.getElementById("inptindakanteks");
			else if(_JENIS === "DIAGNOSATEKS")
				vElfocus	= document.getElementById("inpdiagnosaket");

			vElfocus && vElfocus.focus();
		},350)
	}
	const hdlKDownToggleedititem = (_IDTABEL,_EV) => {
		_IDTABEL 	= parseInt(_IDTABEL)||0;

		if(_EV.keyCode === 27) {
			setToggleditObj({}); return;
		}

		if(_EV.keyCode === 13) {
			if (_EV.target.nodeName === "TEXTAREA") {
				if(_EV.shiftKey) return;
			}

			_EV.stopPropagation();
			_EV.preventDefault();
			hdlKlikToggleprosesitem();
			return;
		}
	}
	const hdlKlikToggleprosesitem = () => {
		apiProsesedititem()
	}
	const hdlKlikMobileedit = (_IDTABEL) => {
		_IDTABEL 	= parseInt(_IDTABEL)||0;if(_IDTABEL <= 0) return;
		setToggleditObj({});

		const vDataitemsArr	= uDatamainObj.items_arr||[];
		const vArridx		= UFunc.getObjectIndeks(vDataitemsArr,_IDTABEL);
		const vCaptionupper	= ((vDataitemsArr[vArridx]||{}).caption_terapi||"").toUpperCase();

		setDlgformObj({
			dlg_header: "Edit: "+vCaptionupper,
			tabel_id: _IDTABEL,
			//tindakan_id: parseInt((vDataitemsArr[vArridx]||{}).tindakan_id)||0,
			//tindakan_caption: (vDataitemsArr[vArridx]||{}).tindakan_caption || "",
			ket_gigi: (vDataitemsArr[vArridx]||{}).ket_gigi || "",
			tindakan: (vDataitemsArr[vArridx]||{}).tindakan || "",
		})
		setDlgformshow(true);

		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);

			if(!isMobile)
				document.getElementById("inpdiagnosacaption") &&
					document.getElementById("inpdiagnosacaption").focus();
		},350)
	}
	const hdlKlikDiagnosalookup = () => {
		//--LOOKUP--/
		const vDatalookupArr = uDatadiagnosaArr.map(vItems =>{ 
			return {id: vItems.id,caption:vItems.nama_diagnosa} 
		})

		uDlglookupObj.lookup_arr 	= vDatalookupArr;
		uDlglookupObj.dlg_header	= ((uBahasaObj.word_lookup||"Lookup")+": "+
			(uBahasaObj.caption_datadiagnosa||"Data Diagnosa"))

		uDlglookupObj.inputvalue 	= "";
		uDlglookupObj.jenislookup 	= uToggleditObj.jenis;
		setDlglookupshow(true)
		//--END LOOKUP--/
	}
	const hdlKlikAnamnesalookup = () => {
		//--LOOKUP--/
		const vDatalookupArr = uDataanamnaseArr.map(vItems =>{ 
			return {id: vItems.id,caption:vItems.nama_anamnase} 
		})

		uDlglookupObj.lookup_arr 	= vDatalookupArr;
		uDlglookupObj.dlg_header	= ((uBahasaObj.word_lookup||"Lookup")+": "+
			(uBahasaObj.caption_dataanamnesa||"Data Anamnesa"))

		uDlglookupObj.inputvalue 	= "";
		uDlglookupObj.jenislookup 	= uToggleditObj.jenis;
		setDlglookupshow(true)
		//--END LOOKUP--/
	}
	const hdlKlikDlglookuppilih = (_IDITEM) => {
		_IDITEM = parseInt(_IDITEM)||0; if(_IDITEM <= 0) return

		//--JIKA_DESKTOP--/
		if(uToggleditObj.jenis === "SUBJECTIVE"
			&& (parseInt(uToggleditObj.tabel_id)||0) <= 0
			) {
			const vArridx	= UFunc.getObjectIndeks(uDataanamnaseArr,_IDITEM);
			setToggleditObj({...uToggleditObj,
				value: _IDITEM,
				value_caption: (uDataanamnaseArr[vArridx]||{}).nama_anamnase || "Undf Anamnesa",
			});

			setTriggeredit(true);
			setDlglookupObj({...uDlglookupObj,init_selected:true})
			setDlglookupshow(false);
			return;
		} else if(uToggleditObj.jenis === "DIAGNOSASEKUNDER"
			&& (parseInt(uToggleditObj.tabel_id)||0) > 0
			) {

			const vArridx	= UFunc.getObjectIndeks(uDatadiagnosaArr,_IDITEM);
			setToggleditObj({...uToggleditObj,
				value: _IDITEM,
				value_caption: (uDatadiagnosaArr[vArridx]||{}).nama_diagnosa || "Undf Diagnosa",
			});

			setTriggeredit(true);
			setDlglookupObj({...uDlglookupObj,init_selected:true})
			setDlglookupshow(false);
			return;
		}
		//--END JIKA_DESKTOP--/

		//--JIKA_MOBILE--/
		const vArridx	= UFunc.getObjectIndeks(uDatadiagnosaArr,_IDITEM);
		setDlgformObj({...uDlgformObj,
			diagnosa_main_id: _IDITEM,
			diagnosa_main: (uDatadiagnosaArr[vArridx]||{}).nama_diagnosa || "Undf Diagnosa",
		});
		setDlglookupshow(false);		
		//--END JIKA_MOBILE--/
	}
	/*const hdlKlikTindakanlookup = () => {
		setDlglookupapiObj({
			...uDlglookupapiObj,
			dlg_header: "Lookup: TINDAKAN ICD-9 CM",
			dlg_keyword: "",
			dlg_jenis: "TINDAKANCAPTION",
			dlg_targetapi: pjson.homepage+"api/api_dataicd9/ld_lookup",
		});

		setDlglookupapishow(true);
	}
	const hdlKlikPilihLookupapi = (_SELECTEDSTR) => {
		_SELECTEDSTR 	= _SELECTEDSTR||"{}";
		
		const vLookupObj= JSON.parse(_SELECTEDSTR);
		if(vLookupObj==={}) return;

		let vElfocus;
		if(uDlglookupapiObj.dlg_jenis === "TINDAKANCAPTION") {
			//console.log("vLookupObj = "+JSON.stringify(vLookupObj));

			setToggleditObj({...uToggleditObj,
				value: vLookupObj.id,
				value_caption: vLookupObj.caption
			});

			setTriggeredit(true);
			setDlglookupapiObj({...uDlglookupapiObj,init_selected:true})
			setDlglookupapishow(false);
			return;
		}

		setDlglookupapiObj({...uDlglookupapiObj,init_selected:true})
		setDlglookupapishow(false);

		let vTimeout = setTimeout(function(){
			clearTimeout(vTimeout);
			vElfocus && vElfocus.focus();
		},350);
	}
	const hdlKlikTindakanhapus = async() => {
		if(await Konfirm(
			"<p><b>Anda Akan MENGHAPUS Tindakan ICD-9</b>..</p>"+
			"<p>Apakah Anda Yakin ?</p>"+
			"")) setTriggeredit(true);
	}//-*/
	const hdlKlikDiagnosasekunderhapus = async() => {
		if(await Konfirm(
			"<p><b>Anda Akan MENGHAPUS Diagnosa Sekunder</b>..</p>"+
			"<p>Apakah Anda Yakin ?</p>"+
			"")) setTriggeredit(true);
	}
	const hdlKlikDlgformsimpan = () => {
		//--VALIDASI--/
		//--END VALIDASI--/

		apiProsesedititem()
	}
	const hdlKlikKirimsatusehat = async() => {
		if((uDatamainObj.satusehat_status||"BELUM")==="SUDAH") {
			showToast(
				"<p class='fw-bolder'>Integrasi Satusehat Sudah Pernah Dilakukan</p>"+
				"<p>Mohon Dicek Kembali, Karena Proses Hanya Dapat Dilakukan SATU kali!</p>"+
				"")
			return;
		}

		if((parseInt(uDatamainObj.id_progress)||0) <= 0) {
			showToast(
				"<p class='fw-bolder'>Data Kunjungan Tidak Valid..</p>"+
				"<p>Kemungkinan Rekam Medis Merupakan Data Lama, Sehingga Data Progress Kunjungan Belum Tercatat!</p>"+
				"")
			return;
		}

		/*//--CEK_ID_PROGRESS--/
		console.log("(Rekammedisform - hdlKlikKirimsatusehat) uDatamainObj",uDatamainObj);
		//--END CEK_ID_PROGRESS--*/

		if(await Konfirm("<p><b>Kirim Data ke Server SATUSEHAT</b>..</p>"+
			"<small class='fst-italic'>"+
			"<p>Data Pemeriksaan Pasien Akan Dikirim ke SATUSEHAT. Proses Ini Hanya Dapat Dilakukan SEKALI.</p>"+
			"<p>Proses Tidak Dapat DIULANGI ataupun DIBATALKAN.</p>"+
			"</small>"+
			"Apakah Anda Yakin ?"+
			"")) apiKirimsatusehat();
	}
	//---END HANDEL--/

	//---INIT_PROCESS--/
	//---END INIT_PROCESS--/

	//---CONTENT--/
	const contentMobile = () => {
		if(uHtml500msg) return "";

		return (
		<CCard className="classbgcard mb-3">
			<CCardHeader className="text-muted classfontsmaller py-0 pt-1">
				<small>Data RM</small>
			</CCardHeader>
			
			<CCardBody>
				<div className="d-flex justify-content-between my-1">
				<small className="pe-1">Tgl Periksa</small>

				<div className="text-end fw-bolder">{UFunc.TglAngka(uDatamainObj.tgl_periksa)}</div>
				</div>

				<div className="d-flex justify-content-between my-1">
				<small className="pe-1">Dokter</small>
				<div className="text-end fw-bolder text-primary">
					{uDatamainObj.dokter_caption || "-"}
				</div>
				</div>

				<div className="d-flex justify-content-between my-1">
				<small className="pe-1">Anamnesa</small>
				<div className="text-end fst-italic">
					{uDatamainObj.anamnase || "-"}
				</div>
				</div>
			</CCardBody>
		</CCard>
		)//->
	}
	const contentTanggal = () => {
		if(uHtml500msg) return "";

		return (
		<center>
			<b>{UFunc.TglAngka(uDatamainObj.tgl_periksa)}</b>
		</center>
		)//>
	}
	const contentDokter = () => {
		if(uHtml500msg) return "";

		return (
		<div className="text-center fw-bolder text-primary">
			{uDatamainObj.dokter_caption || "-"}
		</div>
		)//>
	}
	const contentSubjective = () => {
		if(uHtml500msg) return "";
		if(uDataloading) return "";

		return (
		<>
		<div className="fst-italic">
			{uDatamainObj.anamnase || "-"}
		</div>

		{(uDatamainObj.satusehat_status||"BELUM")!=="SUDAH" && (
		<>
			<div className="my-2 classborderbottom"/>

			<CTooltip className="d-none d-lg-block" content="--Edit Subjective">
			<CLink onClick={()=>hdlKlikToggleeditmain('SUBJECTIVE')} className="classcursorpointer">
				<CIcon icon="cilPencil" className="classikonbox" height={28}/>
			</CLink>
			</CTooltip>
		</>
		)}
		</>
		)//>
	}
	const contentObjective = () => {
		if(uHtml500msg) return "";
		if(uDataloading) return "";

		const vObjectiveObj		= JSON.parse(uDatamainObj.objective_str || "{}");

		return (
		<>
		<div className="fst-italic classfontsmaller">
			<span>BP: <b>{vObjectiveObj.tekanandarahatas || "00"}</b>/<b>{vObjectiveObj.tekanandarahbawah || "00"}</b></span>
			<span className="mx-1">&middot;</span>
			<span>HR: <b>{vObjectiveObj.denyutnadi || "00"}</b>bpm</span>
			<span className="mx-1">&middot;</span>
			<span>BB: <b>{vObjectiveObj.berat || "00"}</b>kg</span>
			<span className="mx-1">&middot;</span>
			<span>SUHU: <b>{vObjectiveObj.suhu || "00"}</b>&deg;C</span>
		</div>

		{(uDatamainObj.satusehat_status||"BELUM")!=="SUDAH" && (
		<>
			<div className="my-2 classborderbottom"/>

			<CTooltip className="d-none d-lg-block" content="--Edit Objective">
			<CLink onClick={()=>hdlKlikToggleeditmain('OBJECTIVE')} className="classcursorpointer">
				<CIcon icon="cilPencil" className="classikonbox" height={28}/>
			</CLink>
			</CTooltip>
		</>
		)}
		</>
		)//>
	}
	const contentDiagnosamain = () => {//--TIDAK_DIPAKAI--/
		if(uHtml500msg) return "";
		if(uDataloading) return "";

		return (
		<small>
		<div className="d-none">{JSON.stringify(uToggleditObj)}</div>
		<CRow className="align-items-stretch">
		<CCol md="6">
		<div className="d-flex justify-content-between">
			<div style={{width:"30%"}}>Diagnosa Utama ICD-10</div>

			{(uToggleditObj.jenis === "DIAGNOSAMAIN" 
				&& (parseInt(uToggleditObj.tabel_id)||0) <= 0
				&& (uToggleditObj.is_processing||false)===true
			) ? (
				<CSpinner size="sm" color="primary"/>
			) : (
			<>
				<div className="text-end" style={{width:"65%"}}>
					<span>{uDatamainObj.diagnosa_main || "-"}</span>
				</div>

				{(uDatamainObj.satusehat_status||"BELUM")!=="SUDAH" && (
				<CLink onClick={()=>hdlKlikToggleeditmain('DIAGNOSAMAIN')} className="classcursorpointer ps-2">
					<CIcon icon="cilPencil" className="classikonbox mx-0" height={23}/>
				</CLink>
				)}
			</>
			)}
		</div>
		</CCol>

		<CCol>
		<div className="d-flex justify-content-between">
			{(uToggleditObj.jenis === "DIAGNOSAMAINTEKS" 
				&& (parseInt(uToggleditObj.tabel_id)||0) <= 0
			) ? (
			<>
				{(uToggleditObj.is_processing||false)===true ? (
					<CSpinner size="sm" color="primary"/>
				) : (
				<CInputGroup size="sm">
				<CFormInput size="sm" maxLength={100}
					placeholder="--Keterangan Diagnosa Utama ICD-10"
					value={uToggleditObj.value}
					onChange={(e)=>setToggleditObj({...uToggleditObj,value:e.target.value})}
					onKeyDown={(e)=>{
						if(e.keyCode === 27) {
							setToggleditObj({}); return;
						}

						if(e.keyCode !== 13) return;

						e.stopPropagation();e.preventDefault();
						hdlKlikToggleprosesmain();
					}}
					id="inpdiagnosaket"/>
				<CInputGroupText className="bg-dark">
					<CLink onClick={()=>hdlKlikToggleprosesmain()} className="classcursorpointer text-white">
					<CIcon icon="cilCheck"/>
					</CLink>
				</CInputGroupText>
				</CInputGroup>
				)}
			</>
			) : (
			<>
				<div className="text-end" style={{width:"95%"}}>
				{(uDatamainObj.diagnosa_main_teks||"").trim() === "" ? (
					<small className="fst-italic text-muted">&middot;&middot; Keterangan Diagnosa Utama: (EMPTY) &middot;&middot;</small>
				) : (
					<span>{uDatamainObj.diagnosa_main_teks}</span>
				)}
				</div>

				<CLink onClick={()=>hdlKlikToggleeditmain('DIAGNOSAMAINTEKS')} className="classcursorpointer ps-2">
				<CIcon icon="cilPencil" className="classikonbox mx-0" height={23}/>
				</CLink>
			</>
			)}
		</div>
		</CCol>
		</CRow>
		</small>
		)//>
	}
	const contentItem = () => {
		if(uHtml500msg) return "";
		if(uDataloading) return (
			<CCard className="classbgcard mb-3">
				<CCardBody className="text-primary text-center py-md-3">
					<span className="classblinking">Loading..</span>
				</CCardBody>
			</CCard>
		)//>

		const vDataitemsArr	= uDatamainObj.items_arr || [];

		if(vDataitemsArr.length <= 0) return (
			<CCard className="classbgcard mb-3">
				<CCardHeader className="text-muted classfontsmaller py-0 pt-1">
					<small>Data RM</small>
				</CCardHeader>
				<CCardBody className="fst-italic text-center">&middot;&middot; Data Terapi Tidak Ada &middot;&middot;</CCardBody>
			</CCard>
		)

		return (
		<CForm>
		{vDataitemsArr.map((vItems,vKeys)=> {
			const {
				caption_terapi,tarif_terapi,diagnosa_ket,
				tindakan,ket_gigi,qty,diagnosa_caption,diagnosa_id,
				id
			} = vItems;

			return (
			<CCard key={vKeys} className="classbgcard mb-3">
				<CCardHeader className="d-flex d-md-block justify-content-between">
					<span className="" style={{width:"5%"}}>{vKeys+1}.</span>
					<div className="d-md-inline-block px-1" style={{minWidth:"85%"}}>
					<b className="text-uppercase">{caption_terapi}</b>
					<span className="d-none d-md-inline-block">
						<span className="mx-1">&middot;</span>
						(
						<b className="text-primary">{UFunc.formatAngka(qty)}</b> UNT
						<span className="mx-1">x</span>
						Rp<b className="text-success">{UFunc.formatAngka(tarif_terapi)}</b>
						)

						<span className="mx-1">&middot;</span>

						<b>{UFunc.formatAngka(parseFloat(tarif_terapi) * parseFloat(qty))}</b>
					</span>
					</div>

					<CLink onClick={()=>hdlKlikMobileedit(id)} className="mx-0 classcursorpointer classikon classikonedit d-md-none"/>
				</CCardHeader>

				<CCardBody>
				<CRow className="align-items-stretch">
					<CCol md="6" className="classfontsmaller">
					<div className="d-flex justify-content-between">
					<small className="pe-1" style={{width:"23%"}}>Diagnosa ICD-10</small>

					{((uToggleditObj.jenis === "DIAGNOSASEKUNDER" || uToggleditObj.jenis === "DIAGNOSASEKUNDERHAPUS") 
						&& uToggleditObj.tabel_id === parseInt(id)
						&& (uToggleditObj.is_processing||false) === true 
					) ? (
						<CSpinner size="sm" color="primary"/>
					) : (
					<>
						<div className="text-end text-capitalize" style={{width:"65%"}}>{diagnosa_caption || "-"}</div>

						{(uDatamainObj.satusehat_status||"BELUM")!=="SUDAH" && (
						<div className="text-end">
							{(parseInt(diagnosa_id)||0) > 0 && (
							<CLink onClick={()=>hdlKlikToggleedititem(id,"DIAGNOSASEKUNDERHAPUS")} className="classcursorpointer ps-2 d-none d-md-inline-block">
								<CIcon icon="cilX" className="classikonbox mx-0 text-danger" height={20}/>
							</CLink>
							)}

							<CLink onClick={()=>hdlKlikToggleedititem(id,"DIAGNOSASEKUNDER")} className="classcursorpointer ps-2 d-none d-md-inline-block">
								<CIcon icon="cilPencil" className="classikonbox mx-0" height={23}/>
							</CLink>
						</div>
						)}
					</>
					)}
					</div>

					<div className="classborderbottom my-2"/>

					<div className="d-flex justify-content-between">
					<small className="pe-1" style={{width:"30%"}}>Keterangan Diagnosa</small>

					{((uToggleditObj.jenis === "DIAGNOSATEKS") 
						&& uToggleditObj.tabel_id === parseInt(id)
					) ? (
					<>
						{((uToggleditObj.is_processing||false) === true 
						) ? (
							<CSpinner size="sm" color="primary"/>
						) : (
						<CInputGroup size="sm">
							<CFormInput size="sm" maxLength={50}
								value={uToggleditObj.value||""}
								onKeyDown={(e)=>hdlKDownToggleedititem(id,e)}
								onChange={(e)=>setToggleditObj({...uToggleditObj,value:e.target.value})}
								id="inpdiagnosaket"/>
							<CButton size="sm" color="dark" onClick={()=>hdlKlikToggleprosesitem()}>
							<CIcon icon="cilCheck"/>
							</CButton>
						</CInputGroup>
						)}
					</>
					) : (
					<>
						<div className="text-end text-capitalize" style={{width:"65%"}}>{diagnosa_ket || "-"}</div>

						{(uDatamainObj.satusehat_status||"BELUM")!=="SUDAH" && (
						<CLink onClick={()=>hdlKlikToggleedititem(id,"DIAGNOSATEKS")} className="classcursorpointer ps-2 d-none d-md-block">
							<CIcon icon="cilPencil" className="classikonbox mx-0" height={23}/>
						</CLink>
						)}
					</>
					)}
					</div>

					<div className="classborderbottom my-2"/>

					<div className="d-flex justify-content-between">
					<small className="pe-1" style={{width:"30%"}}>Nomor Gigi</small>
					{(uToggleditObj.jenis === "KETGIGI" && uToggleditObj.tabel_id === parseInt(id)) ? (
					<>
						{(uToggleditObj.is_processing||false) === false ? (
						<CInputGroup size="sm">
							<CFormInput size="sm" maxLength={50}
								value={uToggleditObj.value||""}
								onKeyDown={(e)=>hdlKDownToggleedititem(id,e)}
								onChange={(e)=>setToggleditObj({...uToggleditObj,value:e.target.value})}
								id="inpnomorgigi"/>
							<CButton size="sm" color="dark" onClick={()=>hdlKlikToggleprosesitem()}>
							<CIcon icon="cilCheck"/>
							</CButton>
						</CInputGroup>
						) : (
						<CSpinner size="sm" color="primary"/>
						)}
					</>
					) : (
					<>
						<div className="text-end" style={{width:"65%"}}>{ket_gigi || "-"}</div>

						<CLink onClick={()=>hdlKlikToggleedititem(id,"KETGIGI")} className="classcursorpointer ps-2 d-none d-md-block">
						<CIcon icon="cilPencil" className="classikonbox mx-0" height={23}/>
						</CLink>
					</>
					)}
					</div>

					<div className="d-md-none classborderbottom my-2"/>
					</CCol>
					
					<CCol className="classfontsmaller">
					
					{(uToggleditObj.jenis === "TINDAKANTEKS" && uToggleditObj.tabel_id === parseInt(id)) ? (
					<>
						{(uToggleditObj.is_processing||false) === false ? (
						<>
						<CInputGroup size="sm" className="align-items-start">
						<CFormTextarea size="sm"
							rows={7}
							className="h-100" 
							value={UFunc.br2nl(uToggleditObj.value||"")}
							onKeyDown={(e)=>hdlKDownToggleedititem(id,e)}
							onChange={(e)=>setToggleditObj({...uToggleditObj,value:UFunc.nl2br(e.target.value)})}
							id="inptindakanteks"/>
						<CButton size="sm" color="dark" onClick={()=>hdlKlikToggleprosesitem()}>
						<CIcon icon="cilCheck"/>
						</CButton>
						</CInputGroup>
						<div className="classpetunjuk">*) {uBahasaObj.petunjuk_textarea}</div>
						</>
						) : (
						<center><CSpinner size="sm" color="primary"/></center>
						)}
					</>
					) : (
					<>
					<div className="d-md-flex justify-content-between">
						<small className="pe-1 d-block" style={{color:"maroon"}}>Keterangan Tindakan</small>
						
						<div className="d-md-none fst-italic">{UFunc.renderHTML(tindakan || "-")}</div>
						
						<div style={{width:"75%"}} className="text-end d-none d-md-block fst-italic">
							{UFunc.renderHTML(tindakan || "-")}
						</div>
						
						<CLink onClick={()=>hdlKlikToggleedititem(id,"TINDAKANTEKS")} className="classcursorpointer ps-2 d-none d-md-block">
						<CIcon icon="cilPencil" className="classikonbox mx-0" height={23}/>
						</CLink>
					</div>
					</>
					)}
					</CCol>
				</CRow>
				</CCardBody>
			</CCard>
			)//->
		})}
		</CForm>
		)//>
	}
	const contentDlgform = () => {
		if(!uISDlgformshow) return (<></>)//->

		return (
		<CForm>
		<CRow className="my-1">
			<CCol xs="4"><small>Diagnosa</small></CCol>
			<CCol className="text-end">
				<CInputGroup size="sm">
				<CFormInput size="sm" readOnly={true}
					placeholder="--Pilih Diagnosa.."
					value={uDlgformObj.diagnosa}
					onChange={(e)=>setDlgformObj({...uDlgformObj,diagnosa: e.target.value})}
					id="inpdiagnosacaption"/>
				<CButton size="sm" color="dark" onClick={()=>hdlKlikDiagnosalookup()} id="btndiagnosalookup">
					<CIcon icon="cilSearch"/>
				</CButton>
				</CInputGroup>
			</CCol>
		</CRow>

		<CRow className="my-1">
			<CCol xs="4"><small>Ket.Diagnosa</small></CCol>
			<CCol className="text-end">
				<CFormInput size="sm" maxLength={255}
					value={uDlgformObj.diagnosa_ket}
					onChange={(e)=>setDlgformObj({...uDlgformObj,diagnosa_ket: e.target.value})}
					id="inpdiagnosaket"/>
			</CCol>
		</CRow>

		<CRow className="my-1">
			<CCol xs="4"><small>Nomor Gigi</small></CCol>
			<CCol className="text-end">
				<CFormInput size="sm" maxLength={255}
					value={uDlgformObj.ket_gigi}
					onChange={(e)=>setDlgformObj({...uDlgformObj,ket_gigi: e.target.value})}
					id="inpnomorgigi"/>
			</CCol>
		</CRow>

		<div className="my-3 classborderbottom"/>

		<CRow className="my-1">
			<CCol md="4"><small style={{color:"maroon"}}>Tindakan</small></CCol>
			<CCol className="text-end">
				<CFormTextarea size="sm"
					rows={5}
					value={UFunc.br2nl(uDlgformObj.tindakan_teks)}
					onChange={(e)=>setDlgformObj({...uDlgformObj,tindakan_teks: UFunc.nl2br(e.target.value)})}
					onKeyDown={(e)=>UFunc.hdlKeyDownInput(e,"btnDialogSimpan",e)}
					id="inptindakanteks"/>
			</CCol>
		</CRow>
		</CForm>
		)//->
	}
	//---END CONTENT--/

	//---REST_API--/
	const apiLoaddata = () => {
		setHtml500msg();

		setDatamainObj({})
		setDataloading(true);
		setLoading(true);

		/*//--TESTING_FRONTEND--/
		console.log("(Rekammedisform - apiLoaddata) LEWAT ");
		let vTimeout = setTimeout(()=>{
			setLoading(false);
		},2000); return
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_rekammedisid : uRekammedisID,
			send_cabangid : uLastinitObj.cabangID || "0",
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_rekammedis/ld_formedit";

		const vTimeBegin = new Date();
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200) { setSessionaktif(false); return response.json(); }})
		.then((output_string) => {
			const vTimeEnd = new Date(); const vTimeDiff = vTimeEnd - vTimeBegin; //in ms
			setDataloading(false);
			setLoading(false);
			if(output_string.tampil) {
				//console.log("(Rekammedisform - apiLoaddata) output_string.dataobject : "+output_string.dataobject);
				setDataanamanseArr(JSON.parse(output_string.dataanamnase || "[]"));
				setDatadiagnosaArr(JSON.parse(output_string.datadiagnosa || "[]"));
				setDatamainObj(JSON.parse(output_string.dataobject || "{}"));
			} else if(output_string.info) {
				setHtml500msg(output_string.info);
			} else if(output_string.errors) {
				console.log("(Rekammedisform - apiLoaddata) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				setHtml500msg("<div class='text-danger'>"+vMsg+"</div>");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired(); return;
			}

			if(vTimeDiff > 500) setSessionaktif(true);
			else {
				let vTimeout = setTimeout(()=>{ clearTimeout(vTimeout); setSessionaktif(true);},500)
			}
		})
		.catch((error) =>{
			setDataloading(false);
			setLoading(false);
			console.log("(Rekammedisform - apiLoaddata) catch-error : "+error);
			setHtml500msg(pjson.mydefault.msg500str.join(" "));
		});
	}
	const apiProseseditmain = () => {
		//--CEK_JIKA_SAMA--/
		let vValuechecked;
		let vValue 			= uToggleditObj.value;
		/*if(uToggleditObj.jenis === "DIAGNOSAMAIN") {
			vValuechecked   = parseInt(uDatamainObj.diagnosa_main_id)||0;
			vValue 			= parseInt(uToggleditObj.value) || 0;
		} else//-*/ if(uToggleditObj.jenis === "SUBJECTIVE") {
			vValuechecked   = parseInt(uDatamainObj.anamnase_id)||0;
			vValue 			= parseInt(uToggleditObj.value) || 0;
		}

		if(vValuechecked === vValue) {
			//console.log("(Rekammedisform - apiProsesedititem) "+vValuechecked+" === "+vValue);
			setToggleditObj({});
			return;
		}
		//--END CEK_JIKA_SAMA--/

		let vElbutton = document.getElementById("btnDialogSimpan");
		vElbutton && (vElbutton.disabled = true);
		setToggleditObj({...uToggleditObj,is_processing:true});
		setLoading(true);
		 
		const vDATAS	= JSON.stringify({
			send_rekammedisid : uRekammedisID,
			send_cabangid : uLastinitObj.cabangID || "0",
			send_editpars : JSON.stringify(uToggleditObj),
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_rekammedis/pr_editrmmain";

		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200) { setSessionaktif(false); return response.json(); }})
		.then((output_string) => {
			setSessionaktif(true);
			vElbutton && (vElbutton.disabled = false);
			setLoading(false);
			if(output_string.sukses) {
				/*if(uToggleditObj.jenis === "DIAGNOSAMAIN") {
					const vIdxdiagnosa	= UFunc.getObjectIndeks(uDatadiagnosaArr,uToggleditObj.value);
					setDatamainObj({
						...uDatamainObj,
						diagnosa_main_id: uToggleditObj.value,
						diagnosa_main: (uDatadiagnosaArr[vIdxdiagnosa]||{}).nama_diagnosa || "Undf Diagnosa",
					});
				} else if(uToggleditObj.jenis === "DIAGNOSAMAINTEKS") {
					setDatamainObj({
						...uDatamainObj,
						diagnosa_main_teks: (uToggleditObj.value||"").trim(),
					});
				} else//-*/ if(uToggleditObj.jenis === "SUBJECTIVE") {
					const vIdxanamnase	= UFunc.getObjectIndeks(uDataanamnaseArr,uToggleditObj.value);

					setDatamainObj({
						...uDatamainObj,
						anamnase_id: uToggleditObj.value,
						anamnase: (uDataanamnaseArr[vIdxanamnase]||{}).nama_anamnase || "Undf Anamnesa",
					});
					uDispatch({type: "set", gDatasubjective: undefined});
				} else if(uToggleditObj.jenis === "OBJECTIVE") {
					const vObjectiveObj = JSON.parse(uToggleditObj.value || "{}");

					setDatamainObj({
						...uDatamainObj,
						objective_str: JSON.stringify(vObjectiveObj),
					});
					uDispatch({type: "set", gDataobjective: undefined});

					setDlgformobjectiveshow(false);
				} 
				setToggleditObj({});
			} else if(output_string.expired) {
				setToggleditObj({});
				setLoading(true); prosesExpired(); return
			} else if(output_string.info) {
				if(uToggleditObj.jenis === "SUBJECTIVE"
					){ setToggleditObj({}); }
				showToast(output_string.info);
			} else if(output_string.errors) {
				if(uToggleditObj.jenis === "SUBJECTIVE"
					){ setToggleditObj({}); }
				console.log("(Rekammedisform - apiProseseditmain) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			}
		})
		.catch((error) =>{
			if(uToggleditObj.jenis === "SUBJECTIVE"
			) {
				setToggleditObj({});
			} else if(uToggleditObj.jenis === "OBJECTIVE"
			) {
				setToggleditObj({...uToggleditObj,is_processing:undefined});
			}

			vElbutton && (vElbutton.disabled = false);
			setLoading(false);
			console.log("(Rekammedisform - apiProseseditmain) catch-error : "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
		});
	}
	const apiProsesedititem = () => {
		const vInitplatform	= uToggleditObj.jenis===undefined ? "MOBILE" : "DESKTOP";
		let vTabelID	= vInitplatform==="MOBILE" ? parseInt(uDlgformObj.tabel_id) : parseInt(uToggleditObj.tabel_id);
		const vArridx	= UFunc.getObjectIndeks((uDatamainObj.items_arr||[]),vTabelID);

		const vElbutton	= document.getElementById("btnDialogSimpan");
		let vDatamobileObj	= {};
		let vValue;
		if(vInitplatform !== "MOBILE") {
			let vValuechecked;
			if(uToggleditObj.jenis === "KETGIGI") {
				vValue 			= (uToggleditObj.value||"").trim().toUpperCase();
				vValuechecked = (((uDatamainObj.items_arr||[])[vArridx] || {}).ket_gigi || "").toUpperCase();
			} else if(uToggleditObj.jenis === "TINDAKANTEKS") {
				vValue 			= (uToggleditObj.value||"").trim().toUpperCase();
				vValuechecked = (((uDatamainObj.items_arr||[])[vArridx] || {}).tindakan_teks || "").toUpperCase();
			/*} else if(uToggleditObj.jenis === "TINDAKANCAPTION") {
				vValuechecked 	= parseInt(((uDatamainObj.items_arr||[])[vArridx] || {}).tindakan_id) || 0;
				vValue 			= parseInt(uToggleditObj.value) || 0;//-*/
			} else if(uToggleditObj.jenis === "DIAGNOSASEKUNDER") {
				vValuechecked 	= parseInt(((uDatamainObj.items_arr||[])[vArridx] || {}).diagnosa_id) || 0;
				vValue 			= parseInt(uToggleditObj.value) || 0;
			} else if(uToggleditObj.jenis === "DIAGNOSATEKS") {
				vValue 			= (uToggleditObj.value||"").trim().toUpperCase();
				vValuechecked = (((uDatamainObj.items_arr||[])[vArridx] || {}).diagnosa_ket || "").toUpperCase();
			} else {
				vValue 			= (uToggleditObj.value||"").trim().toUpperCase();
			}

			if(vValuechecked === vValue) {
				//console.log("(Rekammedisform - apiProsesedititem) "+vValuechecked+" === "+vValue);
				setToggleditObj({});
				return;
			}
		} else {
			vDatamobileObj	= {...uDlgformObj,
				dlg_header: undefined,
			}
			vElbutton && (vElbutton.disabled = true);
			setLoading(true);
		}
		setToggleditObj({...uToggleditObj,is_processing:true}); 

		//console.log("(Rekammedisform - apiProsesedititem) uToggleditObj === "+JSON.stringify(uToggleditObj));
		const vDATAS	= JSON.stringify({
			send_rekammedisid : uRekammedisID,
			send_cabangid : uLastinitObj.cabangID || "0",
			send_editpars: JSON.stringify({
				jenis: uToggleditObj.jenis,
				value: vInitplatform!=="MOBILE" ? uToggleditObj.value : vDatamobileObj,
				tabel_id: vInitplatform!=="MOBILE" ? uToggleditObj.tabel_id : uDlgformObj.tabel_id,
				platform: vInitplatform,
			}),
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_rekammedis/pr_editrmitem";

		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200) { setSessionaktif(false); return response.json(); }})
		.then((output_string) => {
			setSessionaktif(true);
			setToggleditObj({...uToggleditObj,is_processing:false});
			vElbutton && (vElbutton.disabled = false);
			setLoading(false);
			if(output_string.sukses) {
				if(vInitplatform !== "MOBILE") {
					/*if(uToggleditObj.jenis === "TINDAKANCAPTION"){
						(uDatamainObj.items_arr||[])[vArridx].tindakan_id = uToggleditObj.value; 
						(uDatamainObj.items_arr||[])[vArridx].tindakan_caption = 
							uToggleditObj.value_caption || (uDatamainObj.items_arr||[])[vArridx].tindakan_caption;
					} else if(uToggleditObj.jenis === "TINDAKANCAPTIONHAPUS") {
						(uDatamainObj.items_arr||[])[vArridx].tindakan_id 		= 0; 
						(uDatamainObj.items_arr||[])[vArridx].tindakan_caption 	= "";
					} else//-*/ if(uToggleditObj.jenis === "DIAGNOSASEKUNDER"){
						(uDatamainObj.items_arr||[])[vArridx].diagnosa_id = uToggleditObj.value; 
						(uDatamainObj.items_arr||[])[vArridx].diagnosa_caption = 
							uToggleditObj.value_caption || (uDatamainObj.items_arr||[])[vArridx].diagnosa_caption;
					} else if(uToggleditObj.jenis === "DIAGNOSASEKUNDERHAPUS") {
						(uDatamainObj.items_arr||[])[vArridx].diagnosa_id 		= 0; 
						(uDatamainObj.items_arr||[])[vArridx].diagnosa_caption 	= "";
					} else if(uToggleditObj.jenis === "KETGIGI") {
						(uDatamainObj.items_arr||[])[vArridx].ket_gigi =
							uToggleditObj.value; 
					} else if(uToggleditObj.jenis === "TINDAKANTEKS") {
						(uDatamainObj.items_arr||[])[vArridx].tindakan =
							(uToggleditObj.value); 
					} else if(uToggleditObj.jenis === "DIAGNOSATEKS") {
						(uDatamainObj.items_arr||[])[vArridx].diagnosa_ket =
							(uToggleditObj.value); 
					}

					setToggleditObj({});
				} else {
					//(uDatamainObj.items_arr||[])[vArridx].tindakan_id 	= vDatamobileObj.tindakan_id;
					//(uDatamainObj.items_arr||[])[vArridx].tindakan_caption 	= vDatamobileObj.tindakan_caption;
					(uDatamainObj.items_arr||[])[vArridx].ket_gigi 	= vDatamobileObj.ket_gigi;
					(uDatamainObj.items_arr||[])[vArridx].tindakan 	= vDatamobileObj.tindakan;

					setDlgformshow(false);
				}
			} else if(output_string.expired) {
				if(uToggleditObj.jenis === "DIAGNOSASEKUNDER"
					|| uToggleditObj.jenis === "DIAGNOSASEKUNDERHAPUS"
					){ setToggleditObj({}); }

				setLoading(true); prosesExpired(); return
			} else if(output_string.info) {
				if(uToggleditObj.jenis === "DIAGNOSASEKUNDER"
					|| uToggleditObj.jenis === "DIAGNOSASEKUNDERHAPUS"
					){ setToggleditObj({}); }

				showToast(output_string.info);
			} else if(output_string.errors) {
				if(uToggleditObj.jenis === "DIAGNOSASEKUNDER"
					|| uToggleditObj.jenis === "DIAGNOSASEKUNDERHAPUS"
					){ setToggleditObj({}); }
				console.log("(Rekammedisform - apiProsesedititem) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			}
		})
		.catch((error) =>{
			if(uToggleditObj.jenis === "DIAGNOSASEKUNDER"
				|| uToggleditObj.jenis === "DIAGNOSASEKUNDERHAPUS"
			) { 
				setToggleditObj({}); 
			} else setToggleditObj({...uToggleditObj,is_processing:false});

			vElbutton && (vElbutton.disabled = false);
			setLoading(false);
			console.log("(Rekammedisform - apiProsesedititem) catch-error : "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
		});
	}
	const apiKirimsatusehat = () => {
		const vTabelID 			= parseInt(uDatamainObj.id_progress)||0; if(vTabelID <= 0) return;
		const vAccesstoken 		= uTokensatusehatObj.access_token;
		
 		if(!vAccesstoken) {
 			loadToken(apiKirimsatusehat); return;
 		}
		const vLimitedsec		= parseInt(uTokensatusehatObj.expires_in || "0");
		const vTimestampnow 	= new Date();
		const vTimetoken		= new Date(parseInt(uTokensatusehatObj.issued_at || "0"));
		const vSelisih			= UFunc.Datetimeselisih(vTimetoken,vTimestampnow).dtk;

		if(vSelisih > vLimitedsec) {
 			loadToken(apiKirimsatusehat); return;
		}

		setLoading(true);

		/*let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
			vElbutton && (vElbutton.disabled = false);
			setLoading(false);

			initFormawal();
			showToast(uBahasaObj.pesan_sukses,"SUKSES")
		},2000); return;//--*/

		const vDATAS	= JSON.stringify({
			send_tabelid : vTabelID,
			send_accesstoken : vAccesstoken,
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_statuspasien/pr_kirimsatusehat";

		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200){setSessionaktif(false);return response.json(); }})
		.then((output_string) => {
			setSessionaktif(true);
			setLoading(false);
			if(output_string.sukses) {
				const vIHSmessage 	= output_string.ihs_message || "";

				setDatamainObj({...uDatamainObj,satusehat_status:"SUDAH"});
				if(vIHSmessage !== "")
					showToast("SATUSEHAT: <b>"+vIHSmessage+"</b>","SUKSES");

				setEfekview(!uEfekview);
			} else if(output_string.info) {
				showToast(output_string.info);
			} else if(output_string.errors) {
				console.log("(Rekammedisform - apiProsessatusehat) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired();
			}
		})
		.catch((error) =>{
			setLoading(false);
			console.log("(Rekammedisform - apiProsessatusehat) catch-error : "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
		});
	}

	//---END REST_API--/

	//---EFFECT--/
	React.useEffect(()=>{})
	React.useEffect(()=>{
		uDispatch({type: "set", effectApp: !uEfekapp});

		apiLoaddata();

		return () => {
			setDatamainObj({}); setDatadiagnosaArr([]); setDataanamanseArr([]);
			setToggleditObj({});
			setTriggeredit(false);
			setDlgformshow(false);setDlglookupshow(false);
			setDlgformsubjectiveshow(false);setDlgformobjectiveshow(false);
			uDispatch({type: "set", gDatasubjective: undefined});
			uDispatch({type: "set", gDataobjective: undefined});
		}
	},[])
	React.useEffect(()=>{
		if(!uTriggeredit) return;

		setTriggeredit(false);

		if((parseInt(uToggleditObj.tabel_id)||0) > 0) {
			apiProsesedititem();
			return;
		}

		apiProseseditmain();
	},[uTriggeredit]);
	React.useEffect(()=>{
		if(!uISDlgformshow) 
			{ setDlgformObj({}); return }
	},[uISDlgformshow]);
	React.useEffect(()=>{
		if(!uISDlglookupshow) { 
			if((uDlglookupObj.init_selected||false)!==true) setToggleditObj({})
			setDlglookupObj({});
			return 
		}
	},[uISDlglookupshow]);
	/*React.useEffect(()=>{
		if(!uISDlglookupapishow) {
			if((uDlglookupapiObj.init_selected||false)!==true) setToggleditObj({})
			setDlglookupapiObj({}); 
			return
		}
	},[uISDlglookupapishow]);//-*/
	React.useEffect(()=>{
		if(!uISDlgformsubjectiveshow && !uISDlgformsubjectivesimpan)
			{ setToggleditObj({}); return }
	},[uISDlgformsubjectiveshow]);
	React.useEffect(()=>{
		if(!uISDlgformsubjectivesimpan) return;
		uDispatch({type: "set", gISSubjectivesimpan: undefined});

		setToggleditObj({...uToggleditObj,
			value: JSON.stringify(uDatasubjectiveObj),
		})

		//console.log("(Rekammedisform) uDatasubjectiveObj => "+JSON.stringify(uDatasubjectiveObj))
		setTriggeredit(true);
	},[uISDlgformsubjectivesimpan]);
	React.useEffect(()=>{
		if(!uISDlgformobjectiveshow && !uISDlgformobjectivesimpan)
			{ setToggleditObj({}); return }
	},[uISDlgformobjectiveshow]);
	React.useEffect(()=>{
		if(!uISDlgformobjectivesimpan) return;
		uDispatch({type: "set", gISObjectivesimpan: undefined});

		setToggleditObj({...uToggleditObj,
			value: JSON.stringify(uDataobjectiveObj),
		})
		setTriggeredit(true);
	},[uISDlgformobjectivesimpan]);

	//---END EFFECT--/

	//console.log("(Rekammedisform) uNavigate => "+JSON.stringify(uNavigate))
	if(UFunc.isEmpty(uTokenObj)) { prosesExpired(); return ""; }

	return (
		<>
		<div className="wrapper d-flex flex-column min-vh-100 bg-transparent">
		<CHeader position="sticky" className="mb-3 p-0">
		<CContainer fluid className="classheadertop" style={{minHeight:64}}>
			<CHeaderToggler className="px-0" onClick={() => hdlKlikBack() }>
			<CIcon icon="cilArrowCircleLeft" className="align-top me-2" height={30}/>
			</CHeaderToggler>
			
			<CHeaderBrand className="me-auto text-normal">
				<b>Edit Rekam Medis</b>
			</CHeaderBrand>

			{(!uDataloading && !uHtml500msg) && (
			<>
			{((uDatamainObj.waktu_selesai||"")!==""
				&& (uDatamainObj.ihs_pasien||"")!==""
				&& (uDatamainObj.ihs_dokter||"")!==""
			) && (
			<>
				{(uDatamainObj.satusehat_status||"BELUM")!=="SUDAH" ? (
				<CHeaderNav className="">
				<CButton size="sm" color="light"
					className="px-3 fw-bolder border-dark"
					onClick={()=>hdlKlikKirimsatusehat()}
					id="btnKirimSS">
					<CImage src={pjson.homepage+"api\/images\/icon_satusehat.png"} className="me-md-2" height={25}/>
					<span className="d-none d-md-inline">Kirim Satusehat</span>
				</CButton>
				</CHeaderNav>
				) : (
				<CBadge color="light" className="border border-success">
					<CIcon icon="cilCheckAlt" className="align-middle me-1 text-success" height={23}/>
					<CImage src={pjson.homepage+"api\/images\/icon_satusehat.png"} height={20}/>
				</CBadge>
				)}
			</>
			)}
			</>
			)}
		</CContainer>
		</CHeader>

		<div className="body flex-grow-1 px-2 px-lg-5 mb-3">
		<CContainer xxl className="px-0">
			{(uHtml500msg) ? (
			<CCard className="classbgcard my-4">
				<CCardHeader className="d-flex justify-content-between align-items-center">
					<div>Error Page 500</div>
					<CLink onClick={apiLoaddata} className="classcursorpointer classikon classikonreset"/>
				</CCardHeader>
				<CCardBody>
					<div className="m-lg-5">{UFunc.renderHTML(uHtml500msg)}</div>
				</CCardBody>
			</CCard>
			) : (
			<>
				{!uDataloading && (
				<>
				<CRow className="align-items-stretch">
				<CCol className="d-md-none">{contentMobile()}</CCol>

				<CCol md="4" className="mb-3 d-none d-md-block">
				<CCard className="classbgcard h-100">
				<CCardHeader className="text-muted classfontsmaller py-0 pt-1">
					<small>Data RM</small>
				</CCardHeader>
				<CCardBody>
					{contentTanggal()}
					<div className="my-2 classborderbottom"/>
					{contentDokter()}
				</CCardBody>
				</CCard>
				</CCol>

				<CCol md="4" className="mb-3 d-none d-md-block">
				<CCard className="classbgcard h-100">
				<CCardHeader className="text-muted classfontsmaller py-0 pt-1">
					<small>Subjective</small>
				</CCardHeader>
				<CCardBody className="text-center">{contentSubjective()}</CCardBody>
				</CCard>
				</CCol>

				<CCol md="4" className="mb-3 d-none d-md-block">
				<CCard className="classbgcard h-100">
				<CCardHeader className="text-muted classfontsmaller py-0 pt-1">
					<small>Objective</small>
				</CCardHeader>
				<CCardBody className="text-center">{contentObjective()}</CCardBody>
				</CCard>
				</CCol>
				</CRow>

				{1===3 && (
				<CCard className="classbgcard mb-3">
					<CCardHeader className="text-muted classfontsmaller py-0 pt-1">
						<small>Assesment: DIAGNOSA UTAMA</small>
					</CCardHeader>
					<CCardBody>{contentDiagnosamain()}</CCardBody>
				</CCard>
				)}
				</>
				)}

				{contentItem()}
			</>
			)}
		</CContainer>
		</div>		
		</div>

		<MyDialoglookup
			show={uISDlglookupshow}
			toggle={()=>setDlglookupshow(false)}
			dialogHeader={uDlglookupObj.dlg_header||"Lookup Data"}
			inputValue={uDlglookupObj.inputvalue||""}
			dataItemArr={uDlglookupObj.lookup_arr||[]} 
			onKlikPilihItem={hdlKlikDlglookuppilih}
			id="iddialoglookup"
			{...props}/>

		<MyDialogform
			options={{centered:true,size:"lg"}}
			onSimpan={hdlKlikDlgformsimpan}
			show={uISDlgformshow}
			dialogHeader={uDlgformObj.dlg_header||""}
			toggle={()=>setDlgformshow(false)}
			renderContent={contentDlgform()}/>

		<MyDialogformsubjective
			showDlg={uISDlgformsubjectiveshow}
			toggleShow={()=>setDlgformsubjectiveshow(false)}
			{...props}/>

		<MyDialogformobjective
			showDlg={uISDlgformobjectiveshow}
			toggleShow={()=>setDlgformobjectiveshow(false)}
			{...props}/>
		</>
	)//>
}	

export default Rekammedisform